import { css } from 'styled-components';

const text = css`
  letter-spacing: 0.5px;
`;

export const latoRegular = css`
  ${text};
  font-family: 'Lato', 'arial', 'sans-serif';
  font-weight: 400;
`;

export const latoLight = css`
  ${text};
  font-family: 'Lato', 'arial', 'sans-serif';
  font-weight: 300;
`;

export const latoBold = css`
  ${text};
  font-family: 'Lato', 'arial', 'sans-serif';
  font-weight: 700;
`;

export const robotoRegular = css`
  ${text};
  font-family: 'Roboto', 'arial', 'sans-serif';
  font-weight: 400;
`;

export const robotoLight = css`
  ${text};
  font-family: 'Roboto', 'arial', 'sans-serif';
  font-weight: 300;
`;

export const robotoMedium = css`
  ${text};
  font-family: 'Roboto', 'arial', 'sans-serif';
  font-weight: 500;
`;

export const robotoBold = css`
  ${text};
  font-family: 'Roboto', 'arial', 'sans-serif';
  font-weight: 700;
`;
